import TenderOpeningTable from './TenderOpeningTable';

const ProductHydro = ({ refreshTrigger }) => (
  <TenderOpeningTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
  />
);

export default ProductHydro;
